<template>
  <section
    class="account-status-card"
    :class="{ 'account-status-card--loading': loading }"
  >
    <h2 class="account-status-card__title">{{ $t("portalHome.account.title") }}</h2>
    <p class="account-status-card__points">
      {{ balanceGrouped }}
      <span>{{ $t("portalHome.units.points") }}</span>
    </p>
    <p class="account-status-card__updated">
      <template v-if="loading">
        {{ $t("portalHome.account.loading") }}
      </template>
      <template v-else-if="account.updatedAt">
        {{ $t("portalHome.account.lastUpdate", { date: account.updatedAt }) }}
      </template>
      <template v-else>
        {{ $t("portalHome.account.noPointsYet") }}
      </template>
    </p>
  </section>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  account: { type: Object, required: true },
  loading: { type: Boolean, default: false },
});

function formatPointsGrouped(value) {
  const n = Math.trunc(Number(value));
  if (!Number.isFinite(n)) return "0";
  const sign = n < 0 ? "-" : "";
  return (
    sign + String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  );
}

const balanceGrouped = computed(() => formatPointsGrouped(props.account.balance));
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/account-status-card";
</style>
